// src/pages/personalizados/managerPersonalized.service.js
import { djangoApi } from "../../utils/axios/axios.utils";

const AUTH_HEADERS = {
	Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
	"Content-Type": "application/json",
};

export async function getManagerPersonalizedOrders(params = {}) {
	try {
		const res = await djangoApi.get("products/manager/personalized-orders/", {
			params,
			headers: AUTH_HEADERS,
		});

		const data = Array.isArray(res?.data)
			? res.data
			: Array.isArray(res?.data?.results)
				? res.data.results
				: [];

		return {
			ok: true,
			status: res.status,
			data,
			raw: res?.data,
		};
	} catch (error) {
		console.log("Erro ao buscar pedidos gerenciais personalizados:", error);

		return {
			ok: false,
			status: error?.response?.status || 500,
			data: [],
			raw: null,
			message:
				error?.response?.data?.message ||
				"Erro ao buscar pedidos personalizados.",
		};
	}
}

export async function getManagerPersonalizedOrderById(id) {
	try {
		const res = await djangoApi.get(
			`products/manager/personalized-orders/${id}/`,
			{
				headers: AUTH_HEADERS,
			}
		);

		return {
			ok: true,
			status: res.status,
			data: res?.data || null,
		};
	} catch (error) {
		console.log("Erro ao detalhar pedido personalizado:", error);

		return {
			ok: false,
			status: error?.response?.status || 500,
			data: null,
			message:
				error?.response?.data?.message ||
				"Erro ao detalhar pedido.",
		};
	}
}

export async function updateManagerPersonalizedOrder(id, payload) {
	try {
		const res = await djangoApi.patch(
			`products/manager/personalized-orders/${id}/update/`,
			payload,
			{
				headers: AUTH_HEADERS,
			}
		);

		return {
			ok: true,
			status: res.status,
			data: res?.data || null,
			message: "Pedido atualizado com sucesso.",
		};
	} catch (error) {
		console.log("Erro ao atualizar pedido personalizado:", error);

		return {
			ok: false,
			status: error?.response?.status || 500,
			data: null,
			message:
				error?.response?.data?.message ||
				"Erro ao atualizar pedido.",
			errors: error?.response?.data || null,
		};
	}
}

export async function getManagerPersonalizedOrderPaymentSummary(orderId) {
	try {
		const res = await djangoApi.get(
			"products/manager/personalized-orders/transactions/summary-by-order/",
			{
				params: { order_id: orderId },
				headers: AUTH_HEADERS,
			}
		);

		const list = Array.isArray(res?.data) ? res.data : [];
		const data = list.length ? list[0] : null;

		return {
			ok: true,
			status: res.status,
			data,
			raw: res?.data,
		};
	} catch (error) {
		console.log("Erro ao buscar resumo financeiro do pedido:", error);

		return {
			ok: false,
			status: error?.response?.status || 500,
			data: null,
			raw: null,
			message:
				error?.response?.data?.message ||
				"Erro ao buscar resumo financeiro do pedido.",
		};
	}
}